import React from 'react';
import { OfferBox } from './OfferBox';
const resumen = ['7 tomos', '5 bonos', '12 recursos', 'ESI y ciudadanía digital', 'Listo para el aula'];
export function FinalCtaSection() {
  return <section className="w-full bg-ink-900 px-4 py-12 text-cream sm:px-8 sm:py-20" data-id="element-62" data-mp="3qt9p1bjnm8x9">
      <div className="mx-auto max-w-3xl text-center" data-id="element-63" data-mp="3vscl46hnp4t3">
        <h2 className="font-display text-2xl font-extrabold leading-tight sm:text-4xl" data-id="element-64" data-mp="3vrunp6j9ckjl">
          Dejá de empezar desde cero cada vez
        </h2>
        <p className="mt-3 font-sans text-sm text-cream-200 sm:mt-4 sm:text-lg" data-id="element-65" data-mp="333fampjoscaw">
          El próximo tema difícil va a aparecer igual. La diferencia es si vas a
          buscarlo durante horas o si ya vas a tener la propuesta lista.
        </p>

        <ul className="mx-auto mt-4 flex max-w-2xl flex-wrap items-center justify-center gap-1.5 font-sans text-[10px] font-semibold uppercase tracking-[0.1em] text-cream-200 sm:mt-7 sm:gap-x-3 sm:gap-y-2 sm:text-sm sm:tracking-[0.12em]" data-id="element-66" data-mp="3cv2w89tkaz4g">
          {resumen.map(item => <li key={item} className="rounded-full border border-cream/15 px-3 py-1.5 sm:px-4 sm:py-2" data-id="element-67" data-mp="2daoxtywvqkvk">
              {item}
            </li>)}
        </ul>

        <OfferBox className="mt-6 sm:mt-8" data-id="element-68" data-mp="23kvwdqqgbm51" />

        <div className="mt-10 border-t border-cream/15 pt-8 sm:mt-14 sm:pt-12" data-id="element-69" data-mp="1yn3v463x2no6">
          <h3 className="font-display text-xl font-extrabold sm:text-3xl" data-id="element-70" data-mp="1yl153m2rkujg">
            Mega Pack Adolescencia Integral
          </h3>
          <p className="mt-2 font-sans text-xs font-semibold uppercase tracking-[0.14em] text-gold-400 sm:mt-3 sm:text-base" data-id="element-71" data-mp="1plwbmu627re5">
            Menos tiempo buscando. Más tiempo enseñando.
          </p>
        </div>
      </div>
    </section>;
}